import Markdown from 'markdown-to-jsx'
import styles from './highlight.module.css'
import Link from 'next/link'
import Image from 'next/image'


export default function HighlightCard({ data }) {
  return (
    <div className={styles.card}>
      <div style={{ width: '100%' }}>
        <p>{data.titulo}</p>
      </div>
      <div className={styles.text}>
        <Markdown>{data.texto}</Markdown>
      </div>
      <div className={styles.link}>
        {
          data.link !== null && data.link !== '' ?
            <div className={styles.button}>
              <Link href={data.link}>
                <a target="_blank">Simule agora</a>
              </Link>
              <img src="/icons/arrow-right-red.svg" width={24} height={14} loading="lazy" />
            </div>
            : <></>
        }
      </div>
    </div>
  )
}
